<template>
  <div style="width: 100%; height: 100%">
    <canvas v-show="data.length > 0" id="correctionbarchart"></canvas>
    <v-row
      v-show="data.length === 0"
      align="center"
      justify="center"
      no-gutters
    >
      <span class="caption">Aucune correction</span>
    </v-row>
  </div>
</template>

<script>
import Chart from "chart.js";
import moment from "moment";
import { api } from "@/api";
import { round10 } from "round10";

export default {
  name: "CorrectionBarChart",
  props: {
    productFilter: {
      required: true
    },
    start: {
      required: true
    },
    end: {
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    this.getData();
    this.createChart();
  },
  data() {
    return {
      data: [],
      chart: undefined
    };
  },
  methods: {
    async getData() {
      try {
        this.$emit("update:loading", true);
        this.data = await api.getInventoryRecordsCorrections({
          product: this.productFilter,
          start:
            this.start != null
              ? moment(this.start)
                  .hours(0)
                  .minutes(0)
                  .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
              : this.start,
          end:
            this.end != null
              ? moment(this.end)
                  .hours(23)
                  .minutes(59)
                  .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
              : this.end,
          omitted: false,
          grouped: true
        });
        setTimeout(() => {
          this.updateChart();
        }, 100);
      } finally {
        this.$emit("update:loading", false);
      }
    },
    createChart() {
      const ctx = document.getElementById("correctionbarchart");
      this.chart = new Chart(ctx, {
        type: "bar",
        data: {
          datasets: [
            {
              label: "Correction",
              backgroundColor: this.data.map(x =>
                +x.value >= 0 ? "#66BB6A" : "#E57373"
              ),
              data: this.data.map(x => {
                return {
                  x: x.date,
                  y: +x.value,
                  infos: x.infos
                };
              })
            }
          ]
        },
        options: {
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                const label =
                  data.datasets[tooltipItem.datasetIndex].label || "";
                const infos =
                  data.datasets[tooltipItem.datasetIndex].data[
                    tooltipItem.index
                  ].infos;

                if (infos !== null && infos.length > 0) {
                  return `${label}: ${tooltipItem.yLabel} [ ${infos} ]`;
                }
                return `${label}: ${tooltipItem.yLabel}`;
              }
            }
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                type: "time",
                ticks: {
                  minRotation: 90,
                  maxRotation: 90,
                  min: moment(this.start)
                    .subtract(1, "d")
                    .toDate(),
                  max: moment(this.end)
                    .add(1, "d")
                    .toDate()
                },
                time: {
                  unit: "day",
                  minUnit: "day",
                  round: true,
                  displayFormats: {
                    day: "MM/D"
                  },
                  tooltipFormat: "ll"
                },
                gridLines: {
                  zeroLineColor: "rgba(0,0,0,0)",
                  display: false
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  display: true,
                  beginAtZero: true
                },
                gridLines: {
                  zeroLineColor: "rgba(0,0,0,0.2)",
                  color: "rgba(0,0,0,0)"
                }
              }
            ]
          }
        }
      });
    },
    updateChart() {
      this.chart.options.scales.xAxes[0].ticks.min = moment(this.start)
        .subtract(1, "d")
        .toDate();
      this.chart.options.scales.xAxes[0].ticks.max = moment(this.end)
        .add(1, "d")
        .toDate();
      this.chart.data.datasets[0].data = this.data.map(x => {
        return {
          x: x.date,
          y: +x.value,
          infos: x.infos
        };
      });
      this.chart.data.datasets[0].backgroundColor = this.data.map(x =>
        +x.value >= 0 ? "#66BB6A" : "#E57373"
      );
      this.chart.update();
    }
  },
  watch: {
    productFilter(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    start(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    end(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    }
  }
};
</script>

<style></style>
